<template>
  <div>


    <div class="header-wrap">
      <div class="btn-back" v-if="isInside" @click="finishCurrentActivity"/>
      <div class="wel">
        <span>我的标签</span>
      </div>
      <div class="edit" @click="save"> 保存 </div>
    </div>


    <div class="question-list">
      <div class="content">

        <div class="tip"><img src="../../assets/img/ic-tag.png" alt="tag">所有标签均可多选，魔方屋将为您匹配多种整配方案。</div>

        <div class="question" v-for="(question, key) in surveyList">
          <div class="title">{{question.title}}<span v-if="question.need">(必填)<span class="red"> *</span></span></div>
          <div class="opt-wrap">
            <div class="opt" :class="{selected:opt.selected}" v-for="opt in question.options" @click="select(opt)">{{opt.label}}</div>
          </div>
          <div class="line" v-if="surveyList.length - 1 !== key"></div>
        </div>

      </div>
    </div>


  </div>
</template>

<script>
  import store from '../../vuex/store'
  import { mapMutations } from 'vuex'
  import {Toast} from "mint-ui"
  import {getSurveyData, submitSurveyData} from "../../api/api"

  export default {
    name: "MyTags",
    store,
    data(){
      return{
        isInside: true,
        surveyList: []
      }
    },
    mounted() {
      this.surveyList = this.$store.state.surveyList
      this.setToken()
      this.network().getUserSurvey()
    },
    methods:{
      select(opt){
        opt.selected = !opt.selected
      },
      showUserTags(tags){
        this.surveyList.forEach(item => {
          item.options.forEach(option => {
            tags.forEach(tag => {
              if(tag === option.label){
                option.selected = true
              }
            })
          })
        })
      },
      save(){
        let arr = [];
        let isFinishSurvey = 1    // 是否完成了所有必填项

        this.surveyList.forEach(item=>{
          let haveVal = false
          item.options.forEach(i=>{
            if(i.selected){
              arr.push(i.label);
              haveVal = true
            }
          })
          if(item.need && !haveVal && isFinishSurvey != 0){
            isFinishSurvey = 0
          }
        })

        // 有必填项没填不保存
        if(isFinishSurvey === 0){
          this.$uihelper.toast('必填项未完成，保存失败')
          return
        }

        // finished: 判断是否完成必填项 0-必填项未填写完整，1-必填项已填写完整
        this.network().submitData({ids:arr, finished: isFinishSurvey})
      },
      network(){
        return{
          getUserSurvey: async () => {
            const {data} = await getSurveyData()

            let tags

            try{ tags = data.data.detail.label_ids}catch (e) {
              console.warn('没有获取到标签', e)
              return
            }

            this.showUserTags(tags)
          },
          submitData:async(params)=>{
            const {status, data} = await submitSurveyData(params)
            console.log(status, data)
            if(status !== 200) return
            this.$uihelper.toast('提交成功')
            setTimeout(() => { this.backMainActivity() },1500)
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./myTags";
</style>
